import React, { useState } from "react";
import type { BankLinkProps } from "./BankLink";
import PlaidBankLink from "./PlaidBankLink";

/** Add-a-bank for an issuer whose banks are verified with Plaid on the program. */
const PlaidBankIntegration: React.FC<BankLinkProps> = ({
  program,
  accountType,
  renderTrigger,
  onBankAdded,
  refetchBankAccounts,
  onActiveChange,
}) => {
  const [linking, setLinking] = useState(false);
  const setActive = (active: boolean) => {
    setLinking(active);
    onActiveChange?.(active);
  };

  return (
    <>
      {renderTrigger(() => setActive(true), linking)}
      {linking && program && (
        <PlaidBankLink
          programId={program.id}
          accountType={accountType}
          onLinked={([firstId]) => {
            refetchBankAccounts();
            if (onBankAdded && firstId) onBankAdded(firstId);
          }}
          onDone={() => setActive(false)}
        />
      )}
    </>
  );
};

export default PlaidBankIntegration;
